import { connect } from "react-redux";
import {
    getPaymentDetailsList,
    getPaymentDetailsSingle,
    getPaymentDetailsCryptoList,

    createPaymentDetails,
    modifyPaymentDetails,
    removePaymentDetails
} from "actions/paymentDetails";

import PaymentDetails from "./PaymentDetails";


const mapState = ({ auth, paymentDetails, references }) => ({
    permissions: auth.permissions,
    organizationTypeList: references.organization_type_list,
    countryList: references.country_list,
    paymentMethodList: references.payment_method_list,
    data: paymentDetails.items,
    loading: paymentDetails.loading,
    cryptoList: paymentDetails.crypto_items
});

export default connect(mapState, {
    getPaymentDetailsList,
    getPaymentDetailsSingle,
    getPaymentDetailsCryptoList,
    createPaymentDetails,
    modifyPaymentDetails,
    removePaymentDetails
})(PaymentDetails);